// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ck-color-image-caption-background: hsl(0, 0%, 97%);
  --ck-color-image-caption-text: hsl(0, 0%, 20%);
  --ck-color-mention-background: hsla(341, 100%, 30%, 0.1);
  --ck-color-mention-text: hsl(341, 100%, 30%);
  --ck-color-selector-caption-background: hsl(0, 0%, 97%);
  --ck-color-selector-caption-text: hsl(0, 0%, 20%);
  --ck-highlight-marker-blue: hsl(201, 97%, 72%);
  --ck-highlight-marker-green: hsl(120, 93%, 68%);
  --ck-highlight-marker-pink: hsl(345, 96%, 73%);
  --ck-highlight-marker-yellow: hsl(60, 97%, 73%);
  --ck-highlight-pen-green: hsl(112, 100%, 27%);
  --ck-highlight-pen-red: hsl(0, 85%, 49%);
  --ck-image-style-spacing: 1.5em;
  --ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);
  --ck-todo-list-checkmark-size: 16px;
}
.desc-component {
  /* @ckeditor/ckeditor5-table/theme/tablecolumnresize.css */
  /* @ckeditor/ckeditor5-table/theme/tablecolumnresize.css */
  /* @ckeditor/ckeditor5-table/theme/tablecolumnresize.css */
  /* @ckeditor/ckeditor5-table/theme/table.css */
  /* @ckeditor/ckeditor5-table/theme/table.css */
  /* @ckeditor/ckeditor5-table/theme/table.css */
  /* @ckeditor/ckeditor5-table/theme/table.css */
  /* @ckeditor/ckeditor5-table/theme/table.css */
  /* @ckeditor/ckeditor5-table/theme/table.css */
  /* @ckeditor/ckeditor5-media-embed/theme/mediaembed.css */
  /* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */
  /* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */
  /* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/todolist.css */
  /* @ckeditor/ckeditor5-list/theme/list.css */
  /* @ckeditor/ckeditor5-list/theme/list.css */
  /* @ckeditor/ckeditor5-list/theme/list.css */
  /* @ckeditor/ckeditor5-list/theme/list.css */
  /* @ckeditor/ckeditor5-list/theme/list.css */
  /* @ckeditor/ckeditor5-list/theme/list.css */
  /* @ckeditor/ckeditor5-list/theme/list.css */
  /* @ckeditor/ckeditor5-list/theme/list.css */
  /* @ckeditor/ckeditor5-list/theme/list.css */
  /* @ckeditor/ckeditor5-image/theme/imageresize.css */
  /* @ckeditor/ckeditor5-image/theme/imageresize.css */
  /* @ckeditor/ckeditor5-image/theme/imageresize.css */
  /* @ckeditor/ckeditor5-image/theme/imageresize.css */
  /* @ckeditor/ckeditor5-image/theme/image.css */
  /* @ckeditor/ckeditor5-image/theme/image.css */
  /* @ckeditor/ckeditor5-image/theme/image.css */
  /* @ckeditor/ckeditor5-image/theme/image.css */
  /* @ckeditor/ckeditor5-image/theme/image.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-image/theme/imagestyle.css */
  /* @ckeditor/ckeditor5-basic-styles/theme/code.css */
  /* @ckeditor/ckeditor5-block-quote/theme/blockquote.css */
  /* @ckeditor/ckeditor5-block-quote/theme/blockquote.css */
  /* @ckeditor/ckeditor5-highlight/theme/highlight.css */
  /* @ckeditor/ckeditor5-highlight/theme/highlight.css */
  /* @ckeditor/ckeditor5-highlight/theme/highlight.css */
  /* @ckeditor/ckeditor5-highlight/theme/highlight.css */
  /* @ckeditor/ckeditor5-highlight/theme/highlight.css */
  /* @ckeditor/ckeditor5-highlight/theme/highlight.css */
  /* @ckeditor/ckeditor5-font/theme/fontsize.css */
  /* @ckeditor/ckeditor5-font/theme/fontsize.css */
  /* @ckeditor/ckeditor5-font/theme/fontsize.css */
  /* @ckeditor/ckeditor5-font/theme/fontsize.css */
  /* @ckeditor/ckeditor5-mention/theme/mention.css */
  /* @ckeditor/ckeditor5-table/theme/tablecaption.css */
  /* @ckeditor/ckeditor5-code-block/theme/codeblock.css */
  /* @ckeditor/ckeditor5-code-block/theme/codeblock.css */
  /* @ckeditor/ckeditor5-horizontal-line/theme/horizontalline.css */
  /* @ckeditor/ckeditor5-image/theme/imagecaption.css */
}
.desc-component .ck-content {
  overflow: auto;
}
.desc-component .ck-content figure {
  margin: 0;
}
.desc-component .ck-content table,
.desc-component tbody,
.desc-component tr,
.desc-component td {
  border-collapse: collapse;
}
.desc-component .ck-content table tr,
.desc-component tbody tr,
.desc-component tr tr,
.desc-component td tr,
.desc-component .ck-content table td,
.desc-component tbody td,
.desc-component tr td,
.desc-component td td {
  border-collapse: collapse;
  padding: 0 5px 0 5px;
}
.desc-component .ck-content p {
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
}
.desc-component .ck-content .p-padding {
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
  padding: 5px;
}
.desc-component .ck-content .loading {
  color: gray;
}
.desc-component .ck-content a {
  text-decoration: none;
}
.desc-component .ck-content .item-description .title-desc {
  margin: 5px;
  display: block;
  font-weight: 500;
}
.desc-component .ck-content .item-description .title-desc .desc-link .label-desc {
  padding: 0 5px;
}
.desc-component .ck-content .item-description .title-desc .label-desc-no {
  padding: 0 5px;
}
.desc-component .ck-content .table .ck-table-resized {
  table-layout: fixed;
}
.desc-component .ck-content .table table {
  overflow: hidden;
}
.desc-component .ck-content .table td,
.desc-component .ck-content .table th {
  overflow-wrap: break-word;
  position: relative;
}
.desc-component .ck-content .table {
  margin: 0.9em auto;
  display: table;
}
.desc-component .ck-content .table table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  height: 100%;
  border: 1px double hsl(0, 0%, 70%);
}
.desc-component .ck-content .table table td,
.desc-component .ck-content .table table th {
  min-width: 2em;
  padding: 5px;
  border: 1px solid hsl(0, 0%, 75%);
}
.desc-component .ck-content .table table th {
  font-weight: bold;
  background: hsla(0, 0%, 0%, 0.05);
}
.desc-component .ck-content[dir="rtl"] .table th {
  text-align: right;
}
.desc-component .ck-content[dir="ltr"] .table th {
  text-align: left;
}
.desc-component .ck-content .media {
  clear: both;
  margin: 0.9em 0;
  display: block;
  min-width: 15em;
}
.desc-component .ck-content .page-break {
  position: relative;
  clear: both;
  padding: 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.desc-component .ck-content .page-break::after {
  content: '';
  position: absolute;
  border-bottom: 2px dashed hsl(0, 0%, 77%);
  width: 100%;
}
.desc-component .ck-content .page-break__label {
  position: relative;
  z-index: 1;
  padding: 0.3em 0.6em;
  display: block;
  text-transform: uppercase;
  border: 1px solid hsl(0, 0%, 77%);
  border-radius: 2px;
  font-family: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;
  font-size: 0.75em;
  font-weight: bold;
  color: hsl(0, 0%, 20%);
  background: hsl(0, 0%, 100%);
  box-shadow: 2px 2px 1px hsla(0, 0%, 0%, 0.15);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.desc-component .ck-content .todo-list {
  list-style: none;
}
.desc-component .ck-content .todo-list li {
  position: relative;
  margin-bottom: 5px;
}
.desc-component .ck-content .todo-list li .todo-list {
  margin-top: 5px;
}
.desc-component .ck-content .todo-list .todo-list__label > input {
  -webkit-appearance: none;
  display: inline-block;
  position: relative;
  width: var(--ck-todo-list-checkmark-size);
  height: var(--ck-todo-list-checkmark-size);
  vertical-align: middle;
  border: 0;
  left: -25px;
  margin-right: -15px;
  right: 0;
  margin-left: 0;
}
.desc-component .ck-content[dir=rtl] .todo-list .todo-list__label > input {
  left: 0;
  margin-right: 0;
  right: -25px;
  margin-left: -15px;
}
.desc-component .ck-content .todo-list .todo-list__label > input::before {
  display: block;
  position: absolute;
  box-sizing: border-box;
  content: '';
  width: 100%;
  height: 100%;
  border: 1px solid hsl(0, 0%, 20%);
  border-radius: 2px;
  transition: 250ms ease-in-out box-shadow;
}
.desc-component .ck-content .todo-list .todo-list__label > input::after {
  display: block;
  position: absolute;
  box-sizing: content-box;
  pointer-events: none;
  content: '';
  left: calc(var(--ck-todo-list-checkmark-size) / 3);
  top: calc(var(--ck-todo-list-checkmark-size) / 5.3);
  width: calc(var(--ck-todo-list-checkmark-size) / 5.3);
  height: calc(var(--ck-todo-list-checkmark-size) / 2.6);
  border-style: solid;
  border-color: transparent;
  border-width: 0 calc(var(--ck-todo-list-checkmark-size) / 8) calc(var(--ck-todo-list-checkmark-size) / 8) 0;
  transform: rotate(45deg);
}
.desc-component .ck-content .todo-list .todo-list__label > input[checked]::before {
  background: hsl(126, 64%, 41%);
  border-color: hsl(126, 64%, 41%);
}
.desc-component .ck-content .todo-list .todo-list__label > input[checked]::after {
  border-color: hsl(0, 0%, 100%);
}
.desc-component .ck-content .todo-list .todo-list__label .todo-list__label__description {
  vertical-align: middle;
}
.desc-component .ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox] {
  position: absolute;
}
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > input,
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > span[contenteditable=false] > input {
  cursor: pointer;
}
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > input:hover::before,
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > span[contenteditable=false] > input:hover::before {
  box-shadow: 0 0 0 5px hsla(0, 0%, 0%, 0.1);
}
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > span[contenteditable=false] > input {
  -webkit-appearance: none;
  display: inline-block;
  position: relative;
  width: var(--ck-todo-list-checkmark-size);
  height: var(--ck-todo-list-checkmark-size);
  vertical-align: middle;
  border: 0;
  left: -25px;
  margin-right: -15px;
  right: 0;
  margin-left: 0;
}
.desc-component .ck-editor__editable.ck-content[dir=rtl] .todo-list .todo-list__label > span[contenteditable=false] > input {
  left: 0;
  margin-right: 0;
  right: -25px;
  margin-left: -15px;
}
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > span[contenteditable=false] > input::before {
  display: block;
  position: absolute;
  box-sizing: border-box;
  content: '';
  width: 100%;
  height: 100%;
  border: 1px solid hsl(0, 0%, 20%);
  border-radius: 2px;
  transition: 250ms ease-in-out box-shadow;
}
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > span[contenteditable=false] > input::after {
  display: block;
  position: absolute;
  box-sizing: content-box;
  pointer-events: none;
  content: '';
  left: calc(var(--ck-todo-list-checkmark-size) / 3);
  top: calc(var(--ck-todo-list-checkmark-size) / 5.3);
  width: calc(var(--ck-todo-list-checkmark-size) / 5.3);
  height: calc(var(--ck-todo-list-checkmark-size) / 2.6);
  border-style: solid;
  border-color: transparent;
  border-width: 0 calc(var(--ck-todo-list-checkmark-size) / 8) calc(var(--ck-todo-list-checkmark-size) / 8) 0;
  transform: rotate(45deg);
}
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > span[contenteditable=false] > input[checked]::before {
  background: hsl(126, 64%, 41%);
  border-color: hsl(126, 64%, 41%);
}
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > span[contenteditable=false] > input[checked]::after {
  border-color: hsl(0, 0%, 100%);
}
.desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox] {
  position: absolute;
}
.desc-component .ck-content ol {
  list-style-type: decimal;
}
.desc-component .ck-content ol ol {
  list-style-type: lower-latin;
}
.desc-component .ck-content ol ol ol {
  list-style-type: lower-roman;
}
.desc-component .ck-content ol ol ol ol {
  list-style-type: upper-latin;
}
.desc-component .ck-content ol ol ol ol ol {
  list-style-type: upper-roman;
}
.desc-component .ck-content ul {
  list-style-type: disc;
}
.desc-component .ck-content ul ul {
  list-style-type: circle;
}
.desc-component .ck-content ul ul ul {
  list-style-type: square;
}
.desc-component .ck-content ul ul ul ul {
  list-style-type: square;
}
.desc-component .ck-content img.image_resized {
  height: auto;
}
.desc-component .ck-content .image.image_resized {
  max-width: 100%;
  display: block;
  box-sizing: border-box;
}
.desc-component .ck-content .image.image_resized img {
  width: 100%;
}
.desc-component .ck-content .image.image_resized > figcaption {
  display: block;
}
.desc-component .ck-content .image {
  display: table;
  clear: both;
  text-align: center;
  margin: 0.9em auto;
  min-width: 50px;
}
.desc-component .ck-content .image img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  min-width: 100%;
  height: auto;
}
.desc-component .ck-content .image-inline {
  /*
     * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).;
     * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.
     * This strange behavior does not happen with inline-flex.
     */
  display: inline-flex;
  max-width: 100%;
  align-items: flex-start;
}
.desc-component .ck-content .image-inline picture {
  display: flex;
}
.desc-component .ck-content .image-inline picture,
.desc-component .ck-content .image-inline img {
  flex-grow: 1;
  flex-shrink: 1;
  max-width: 100%;
}
.desc-component .ck-content .image.image-style-block-align-left,
.desc-component .ck-content .image.image-style-block-align-right {
  max-width: calc(100% - var(--ck-image-style-spacing));
}
.desc-component .ck-content .image.image-style-align-left,
.desc-component .ck-content .image.image-style-align-right {
  clear: none;
}
.desc-component .ck-content .image.image-style-side {
  float: right;
  margin-left: var(--ck-image-style-spacing);
  max-width: 50%;
}
.desc-component .ck-content .image.image-style-align-left {
  float: left;
  margin-right: var(--ck-image-style-spacing);
}
.desc-component .ck-content .image.image-style-align-right {
  float: right;
  margin-left: var(--ck-image-style-spacing);
}
.desc-component .ck-content .image.image-style-block-align-right {
  margin-right: 0;
  margin-left: auto;
}
.desc-component .ck-content .image.image-style-block-align-left {
  margin-left: 0;
  margin-right: auto;
}
.desc-component .ck-content .image-style-align-center {
  margin-left: auto;
  margin-right: auto;
}
.desc-component .ck-content .image-style-align-left {
  float: left;
  margin-right: var(--ck-image-style-spacing);
}
.desc-component .ck-content .image-style-align-right {
  float: right;
  margin-left: var(--ck-image-style-spacing);
}
.desc-component .ck-content p + .image.image-style-align-left,
.desc-component .ck-content p + .image.image-style-align-right,
.desc-component .ck-content p + .image.image-style-side {
  margin-top: 0;
}
.desc-component .ck-content .image-inline.image-style-align-left,
.desc-component .ck-content .image-inline.image-style-align-right {
  margin-top: var(--ck-inline-image-style-spacing);
  margin-bottom: var(--ck-inline-image-style-spacing);
}
.desc-component .ck-content .image-inline.image-style-align-left {
  margin-right: var(--ck-inline-image-style-spacing);
}
.desc-component .ck-content .image-inline.image-style-align-right {
  margin-left: var(--ck-inline-image-style-spacing);
}
.desc-component .ck-content code {
  background-color: hsla(0, 0%, 78%, 0.3);
  padding: 0.15em;
  border-radius: 2px;
}
.desc-component .ck-content blockquote {
  overflow: hidden;
  padding-right: 1.5em;
  padding-left: 1.5em;
  margin-left: 0;
  margin-right: 0;
  font-style: italic;
  border-left: solid 5px hsl(0, 0%, 80%);
}
.desc-component .ck-content[dir="rtl"] blockquote {
  border-left: 0;
  border-right: solid 5px hsl(0, 0%, 80%);
}
.desc-component .ck-content .marker-yellow {
  background-color: var(--ck-highlight-marker-yellow);
}
.desc-component .ck-content .marker-green {
  background-color: var(--ck-highlight-marker-green);
}
.desc-component .ck-content .marker-pink {
  background-color: var(--ck-highlight-marker-pink);
}
.desc-component .ck-content .marker-blue {
  background-color: var(--ck-highlight-marker-blue);
}
.desc-component .ck-content .pen-red {
  color: var(--ck-highlight-pen-red);
  background-color: transparent;
}
.desc-component .ck-content .pen-green {
  color: var(--ck-highlight-pen-green);
  background-color: transparent;
}
.desc-component .ck-content .text-tiny {
  font-size: 0.7em;
}
.desc-component .ck-content .text-small {
  font-size: 0.85em;
}
.desc-component .ck-content .text-big {
  font-size: 1.4em;
}
.desc-component .ck-content .text-huge {
  font-size: 1.8em;
}
.desc-component .ck-content .mention {
  background: var(--ck-color-mention-background);
  color: var(--ck-color-mention-text);
}
.desc-component .ck-content .table > figcaption {
  display: table-caption;
  caption-side: top;
  word-break: break-word;
  text-align: center;
  color: var(--ck-color-selector-caption-text);
  background-color: var(--ck-color-selector-caption-background);
  padding: 0.6em;
  font-size: 0.75em;
  outline-offset: -1px;
}
.desc-component .ck-content pre {
  padding: 1em;
  color: hsl(0, 0%, 20.8%);
  background: hsla(0, 0%, 78%, 0.3);
  border: 1px solid hsl(0, 0%, 77%);
  border-radius: 2px;
  text-align: left;
  direction: ltr;
  tab-size: 4;
  white-space: pre-wrap;
  font-style: normal;
  min-width: 200px;
}
.desc-component .ck-content pre code {
  background: unset;
  padding: 0;
  border-radius: 0;
}
.desc-component .ck-content hr {
  margin: 15px 0;
  height: 4px;
  background: hsl(0, 0%, 87%);
  border: 0;
}
.desc-component .ck-content .image > figcaption {
  display: table-caption;
  caption-side: bottom;
  word-break: break-word;
  color: var(--ck-color-image-caption-text);
  background-color: var(--ck-color-image-caption-background);
  padding: 0.6em;
  font-size: 0.75em;
  outline-offset: -1px;
}
@media print {
  .desc-component {
    /* @ckeditor/ckeditor5-table/theme/table.css */
    /* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */
    /* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */
    /* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */
  }
  .desc-component .ck-content .table table {
    height: initial;
  }
  .desc-component .ck-content .page-break {
    padding: 0;
  }
  .desc-component .ck-content .page-break::after {
    display: none;
  }
  .desc-component .ck-content *:has(+ .page-break) {
    margin-bottom: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .desc-component {
    /* @ckeditor/ckeditor5-list/theme/todolist.css */
    /* @ckeditor/ckeditor5-list/theme/todolist.css */
  }
  .desc-component .ck-content .todo-list .todo-list__label > input::before {
    transition: none;
  }
  .desc-component .ck-editor__editable.ck-content .todo-list .todo-list__label > span[contenteditable=false] > input::before {
    transition: none;
  }
}
@media (forced-colors: active) {
  .desc-component {
    /* @ckeditor/ckeditor5-table/theme/tablecaption.css */
    /* @ckeditor/ckeditor5-image/theme/imagecaption.css */
  }
  .desc-component .ck-content .table > figcaption {
    background-color: unset;
    color: unset;
  }
  .desc-component .ck-content .image > figcaption {
    background-color: unset;
    color: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/resource/nodepkg/description/DescComponent.less"],"names":[],"mappings":"AAAA;EACC,oDAAA;EACA,8CAAA;EACA,wDAAA;EACA,4CAAA;EACA,uDAAA;EACA,iDAAA;EACA,8CAAA;EACA,+CAAA;EACA,8CAAA;EACA,+CAAA;EACA,6CAAA;EACA,wCAAA;EACA,+BAAA;EACA,wEAAA;EACA,mCAAA;AACD;AAEA;EAAE,0DAA0D;EAC1D,0DAA0D;EAC1D,0DAA0D;EAC1D,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,yDAAyD;EACzD,uDAAuD;EACvD,uDAAuD;EACvD,uDAAuD;EACvD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,oDAAoD;EACpD,oDAAoD;EACpD,oDAAoD;EACpD,oDAAoD;EACpD,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,oDAAoD;EACpD,yDAAyD;EACzD,yDAAyD;EACzD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,kDAAkD;EAClD,qDAAqD;EACrD,uDAAuD;EACvD,uDAAuD;EACvD,iEAAiE;EACjE,qDAAqD;AACvD;AApFA;EAEE,cAAA;AAqFF;AAvFA;EAME,SAAA;AAoFF;AA1FA;;;;EAaE,yBAAA;AAmFF;AAhGA;;;;;;;;EAiBG,yBAAA;EACA,oBAAA;AAyFH;AA3GA;EAuBE,cAAA;EACA,qBAAA;EACA,mBAAA;AAuFF;AAhHA;EA6BE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAsFF;AAtHA;EAoCE,WAAA;AAqFF;AAzHA;EAwCE,qBAAA;AAoFF;AA5HA;EA6CG,WAAA;EACA,cAAA;EACA,gBAAA;AAkFH;AAjIA;EAmDK,cAAA;AAiFL;AApIA;EAwDI,cAAA;AA+EJ;AAvIA;EAgEE,mBAAA;AA0EF;AA1IA;EAqEE,gBAAA;AAwEF;AA7IA;;EA2EE,yBAAA;EACA,kBAAA;AAsEF;AAlJA;EAiFE,kBAAA;EACA,cAAA;AAoEF;AAtJA;EAuFE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AAkEF;AA7JA;;EAiGE,cAAA;EACA,YAAA;EACA,iCAAA;AAgEF;AAnKA;EAwGE,iBAAA;EACA,iCAAA;AA8DF;AAvKA;EA8GE,iBAAA;AA4DF;AA1KA;EAmHE,gBAAA;AA0DF;AA7KA;EAwHE,WAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAwDF;AAnLA;EAgIE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAsDF;AA3LA;EA0IE,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,WAAA;AAoDF;AAjMA;EAkJE,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,0DAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6CAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAkDF;AApNA;EAuKE,gBAAA;AAgDF;AAvNA;EA4KE,kBAAA;EACA,kBAAA;AA8CF;AA3NA;EAkLE,eAAA;AA4CF;AA9NA;EAuLE,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yCAAA;EACA,0CAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA0CF;AA3OA;EAsME,OAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAwCF;AAjPA;EA8ME,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,wCAAA;AAsCF;AA5PA;EA2NE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;EACA,kDAAA;EACA,mDAAA;EACA,qDAAA;EACA,sDAAA;EACA,mBAAA;EACA,yBAAA;EACA,2GAAA;EACA,wBAAA;AAoCF;AA3QA;EA4OE,8BAAA;EACA,gCAAA;AAkCF;AA/QA;EAkPE,8BAAA;AAgCF;AAlRA;EAuPE,sBAAA;AA8BF;AArRA;EA4PE,kBAAA;AA4BF;AAxRA;;EAkQE,eAAA;AA0BF;AA5RA;;EAwQE,0CAAA;AAwBF;AAhSA;EA6QE,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yCAAA;EACA,0CAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAsBF;AA7SA;EA4RE,OAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAoBF;AAnTA;EAoSE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,wCAAA;AAkBF;AA9TA;EAiTE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;EACA,kDAAA;EACA,mDAAA;EACA,qDAAA;EACA,sDAAA;EACA,mBAAA;EACA,yBAAA;EACA,2GAAA;EACA,wBAAA;AAgBF;AA7UA;EAkUE,8BAAA;EACA,gCAAA;AAcF;AAjVA;EAwUE,8BAAA;AAYF;AApVA;EA6UE,kBAAA;AAUF;AAvVA;EAkVE,wBAAA;AAQF;AA1VA;EAuVE,4BAAA;AAMF;AA7VA;EA4VE,4BAAA;AAIF;AAhWA;EAiWE,4BAAA;AAEF;AAnWA;EAsWE,4BAAA;AAAF;AAtWA;EA2WE,qBAAA;AAFF;AAzWA;EAgXE,uBAAA;AAJF;AA5WA;EAqXE,uBAAA;AANF;AA/WA;EA0XE,uBAAA;AARF;AAlXA;EA+XE,YAAA;AAVF;AArXA;EAoYE,eAAA;EACA,cAAA;EACA,sBAAA;AAZF;AA1XA;EA2YE,WAAA;AAdF;AA7XA;EAgZE,cAAA;AAhBF;AAhYA;EAqZE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAlBF;AAvYA;EA8ZE,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AApBF;AA9YA;EAgZE;;;;MAII;EAwBJ,oBAAA;EACA,eAAA;EACA,uBAAA;AAtBF;AAxZA;EAmbE,aAAA;AAxBF;AA3ZA;;EAybE,YAAA;EACA,cAAA;EACA,eAAA;AA1BF;AAjaA;;EAicE,qDAAA;AA5BF;AAraA;;EAucE,WAAA;AA9BF;AAzaA;EA4cE,YAAA;EACA,0CAAA;EACA,cAAA;AAhCF;AA9aA;EAmdE,WAAA;EACA,2CAAA;AAlCF;AAlbA;EAydE,YAAA;EACA,0CAAA;AApCF;AAtbA;EA+dE,eAAA;EACA,iBAAA;AAtCF;AA1bA;EAqeE,cAAA;EACA,kBAAA;AAxCF;AA9bA;EA2eE,iBAAA;EACA,kBAAA;AA1CF;AAlcA;EAifE,WAAA;EACA,2CAAA;AA5CF;AAtcA;EAufE,YAAA;EACA,0CAAA;AA9CF;AA1cA;;;EA+fE,aAAA;AAhDF;AA/cA;;EAqgBE,gDAAA;EACA,mDAAA;AAlDF;AApdA;EA2gBE,kDAAA;AApDF;AAvdA;EAghBE,iDAAA;AAtDF;AA1dA;EAqhBE,uCAAA;EACA,eAAA;EACA,kBAAA;AAxDF;AA/dA;EA4hBE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;AA1DF;AAxeA;EAuiBE,cAAA;EACA,uCAAA;AA5DF;AA5eA;EA6iBE,mDAAA;AA9DF;AA/eA;EAkjBE,kDAAA;AAhEF;AAlfA;EAujBE,iDAAA;AAlEF;AArfA;EA4jBE,iDAAA;AApEF;AAxfA;EAikBE,kCAAA;EACA,6BAAA;AAtEF;AA5fA;EAukBE,oCAAA;EACA,6BAAA;AAxEF;AAhgBA;EA6kBE,gBAAA;AA1EF;AAngBA;EAklBE,iBAAA;AA5EF;AAtgBA;EAulBE,gBAAA;AA9EF;AAzgBA;EA4lBE,gBAAA;AAhFF;AA5gBA;EAimBE,8CAAA;EACA,mCAAA;AAlFF;AAhhBA;EAumBE,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,4CAAA;EACA,6DAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AApFF;AA3hBA;EAonBE,YAAA;EACA,wBAAA;EACA,iCAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAtFF;AAxiBA;EAmoBE,iBAAA;EACA,UAAA;EACA,gBAAA;AAxFF;AA7iBA;EA0oBE,cAAA;EACA,WAAA;EACA,2BAAA;EACA,SAAA;AA1FF;AAnjBA;EAkpBE,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yCAAA;EACA,0DAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AA5FF;AA+FC;EAAA;IA5FG,8CAA8C;IAC9C,uDAAuD;IACvD,uDAAuD;IACvD,uDAAuD;EACzD;EAwFD;IAIE,eAAA;EAzFD;EAqFD;IASE,UAAA;EA3FD;EAkFD;IAcE,aAAA;EA7FD;EA+ED;IAmBE,gBAAA;EA/FD;AACF;AAkGC;EAAA;IA/FG,gDAAgD;IAChD,gDAAgD;EAClD;EA6FD;IAIE,gBAAA;EA9FD;EA0FD;IASE,gBAAA;EAhGD;AACF;AAmGC;EAAA;IAhGG,qDAAqD;IACrD,qDAAqD;EACvD;EA8FD;IAIE,uBAAA;IACA,YAAA;EA/FD;EA0FD;IAUE,uBAAA;IACA,YAAA;EAjGD;AACF","sourcesContent":[":root {\n\t--ck-color-image-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-image-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-mention-background: hsla(341, 100%, 30%, 0.1);\n\t--ck-color-mention-text: hsl(341, 100%, 30%);\n\t--ck-color-selector-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-selector-caption-text: hsl(0, 0%, 20%);\n\t--ck-highlight-marker-blue: hsl(201, 97%, 72%);\n\t--ck-highlight-marker-green: hsl(120, 93%, 68%);\n\t--ck-highlight-marker-pink: hsl(345, 96%, 73%);\n\t--ck-highlight-marker-yellow: hsl(60, 97%, 73%);\n\t--ck-highlight-pen-green: hsl(112, 100%, 27%);\n\t--ck-highlight-pen-red: hsl(0, 85%, 49%);\n\t--ck-image-style-spacing: 1.5em;\n\t--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n\t--ck-todo-list-checkmark-size: 16px;\n}\n\n.desc-component {\n\t.ck-content {\n\t\toverflow: auto;\n\t}\n\n\t.ck-content figure {\n\t\tmargin: 0;\n\t}\n\n\t.ck-content table,\n\ttbody,\n\ttr,\n\ttd {\n\t\tborder-collapse: collapse;\n\n\t\ttr,\n\t\ttd {\n\t\t\tborder-collapse: collapse;\n\t\t\tpadding: 0 5px 0 5px;\n\t\t}\n\t}\n\n\t.ck-content p {\n\t\tdisplay: block;\n\t\tmargin-block-start: 0;\n\t\tmargin-block-end: 0;\n\t}\n\n\t.ck-content .p-padding {\n\t\tdisplay: block;\n\t\tmargin-block-start: 0;\n\t\tmargin-block-end: 0;\n\t\tpadding: 5px;\n\t}\n\n\t.ck-content .loading {\n\t\tcolor: gray;\n\t}\n\n\t.ck-content a {\n\t\ttext-decoration: none;\n\t}\n\n\t.ck-content .item-description {\n\t\t.title-desc {\n\t\t\tmargin: 5px;\n\t\t\tdisplay: block;\n\t\t\tfont-weight: 500;\n\n\t\t\t.desc-link {\n\t\t\t\t.label-desc {\n\t\t\t\t\tpadding: 0 5px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.label-desc-no {\n\t\t\t\tpadding: 0 5px;\n\t\t\t}\n\t\t}\n\t}\n\n\n\t/* @ckeditor/ckeditor5-table/theme/tablecolumnresize.css */\n\t.ck-content .table .ck-table-resized {\n\t\ttable-layout: fixed;\n\t}\n\n\t/* @ckeditor/ckeditor5-table/theme/tablecolumnresize.css */\n\t.ck-content .table table {\n\t\toverflow: hidden;\n\t}\n\n\t/* @ckeditor/ckeditor5-table/theme/tablecolumnresize.css */\n\t.ck-content .table td,\n\t.ck-content .table th {\n\t\toverflow-wrap: break-word;\n\t\tposition: relative;\n\t}\n\n\t/* @ckeditor/ckeditor5-table/theme/table.css */\n\t.ck-content .table {\n\t\tmargin: 0.9em auto;\n\t\tdisplay: table;\n\t}\n\n\t/* @ckeditor/ckeditor5-table/theme/table.css */\n\t.ck-content .table table {\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\t}\n\n\t/* @ckeditor/ckeditor5-table/theme/table.css */\n\t.ck-content .table table td,\n\t.ck-content .table table th {\n\t\tmin-width: 2em;\n\t\tpadding: 5px;\n\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t}\n\n\t/* @ckeditor/ckeditor5-table/theme/table.css */\n\t.ck-content .table table th {\n\t\tfont-weight: bold;\n\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t}\n\n\t/* @ckeditor/ckeditor5-table/theme/table.css */\n\t.ck-content[dir=\"rtl\"] .table th {\n\t\ttext-align: right;\n\t}\n\n\t/* @ckeditor/ckeditor5-table/theme/table.css */\n\t.ck-content[dir=\"ltr\"] .table th {\n\t\ttext-align: left;\n\t}\n\n\t/* @ckeditor/ckeditor5-media-embed/theme/mediaembed.css */\n\t.ck-content .media {\n\t\tclear: both;\n\t\tmargin: 0.9em 0;\n\t\tdisplay: block;\n\t\tmin-width: 15em;\n\t}\n\n\t/* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */\n\t.ck-content .page-break {\n\t\tposition: relative;\n\t\tclear: both;\n\t\tpadding: 5px 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\n\t/* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */\n\t.ck-content .page-break::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tborder-bottom: 2px dashed hsl(0, 0%, 77%);\n\t\twidth: 100%;\n\t}\n\n\t/* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */\n\t.ck-content .page-break__label {\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\tpadding: .3em .6em;\n\t\tdisplay: block;\n\t\ttext-transform: uppercase;\n\t\tborder: 1px solid hsl(0, 0%, 77%);\n\t\tborder-radius: 2px;\n\t\tfont-family: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\t\tfont-size: 0.75em;\n\t\tfont-weight: bold;\n\t\tcolor: hsl(0, 0%, 20%);\n\t\tbackground: hsl(0, 0%, 100%);\n\t\tbox-shadow: 2px 2px 1px hsla(0, 0%, 0%, 0.15);\n\t\t-webkit-user-select: none;\n\t\t-moz-user-select: none;\n\t\t-ms-user-select: none;\n\t\tuser-select: none;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list {\n\t\tlist-style: none;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list li {\n\t\tposition: relative;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list li .todo-list {\n\t\tmargin-top: 5px;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list .todo-list__label>input {\n\t\t-webkit-appearance: none;\n\t\tdisplay: inline-block;\n\t\tposition: relative;\n\t\twidth: var(--ck-todo-list-checkmark-size);\n\t\theight: var(--ck-todo-list-checkmark-size);\n\t\tvertical-align: middle;\n\t\tborder: 0;\n\t\tleft: -25px;\n\t\tmargin-right: -15px;\n\t\tright: 0;\n\t\tmargin-left: 0;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content[dir=rtl] .todo-list .todo-list__label>input {\n\t\tleft: 0;\n\t\tmargin-right: 0;\n\t\tright: -25px;\n\t\tmargin-left: -15px;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list .todo-list__label>input::before {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: border-box;\n\t\tcontent: '';\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 1px solid hsl(0, 0%, 20%);\n\t\tborder-radius: 2px;\n\t\ttransition: 250ms ease-in-out box-shadow;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list .todo-list__label>input::after {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: content-box;\n\t\tpointer-events: none;\n\t\tcontent: '';\n\t\tleft: calc(var(--ck-todo-list-checkmark-size) / 3);\n\t\ttop: calc(var(--ck-todo-list-checkmark-size) / 5.3);\n\t\twidth: calc(var(--ck-todo-list-checkmark-size) / 5.3);\n\t\theight: calc(var(--ck-todo-list-checkmark-size) / 2.6);\n\t\tborder-style: solid;\n\t\tborder-color: transparent;\n\t\tborder-width: 0 calc(var(--ck-todo-list-checkmark-size) / 8) calc(var(--ck-todo-list-checkmark-size) / 8) 0;\n\t\ttransform: rotate(45deg);\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list .todo-list__label>input[checked]::before {\n\t\tbackground: hsl(126, 64%, 41%);\n\t\tborder-color: hsl(126, 64%, 41%);\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list .todo-list__label>input[checked]::after {\n\t\tborder-color: hsl(0, 0%, 100%);\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list .todo-list__label .todo-list__label__description {\n\t\tvertical-align: middle;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox] {\n\t\tposition: absolute;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label>input,\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input {\n\t\tcursor: pointer;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label>input:hover::before,\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:hover::before {\n\t\tbox-shadow: 0 0 0 5px hsla(0, 0%, 0%, 0.1);\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input {\n\t\t-webkit-appearance: none;\n\t\tdisplay: inline-block;\n\t\tposition: relative;\n\t\twidth: var(--ck-todo-list-checkmark-size);\n\t\theight: var(--ck-todo-list-checkmark-size);\n\t\tvertical-align: middle;\n\t\tborder: 0;\n\t\tleft: -25px;\n\t\tmargin-right: -15px;\n\t\tright: 0;\n\t\tmargin-left: 0;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-editor__editable.ck-content[dir=rtl] .todo-list .todo-list__label>span[contenteditable=false]>input {\n\t\tleft: 0;\n\t\tmargin-right: 0;\n\t\tright: -25px;\n\t\tmargin-left: -15px;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input::before {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: border-box;\n\t\tcontent: '';\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 1px solid hsl(0, 0%, 20%);\n\t\tborder-radius: 2px;\n\t\ttransition: 250ms ease-in-out box-shadow;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input::after {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: content-box;\n\t\tpointer-events: none;\n\t\tcontent: '';\n\t\tleft: calc(var(--ck-todo-list-checkmark-size) / 3);\n\t\ttop: calc(var(--ck-todo-list-checkmark-size) / 5.3);\n\t\twidth: calc(var(--ck-todo-list-checkmark-size) / 5.3);\n\t\theight: calc(var(--ck-todo-list-checkmark-size) / 2.6);\n\t\tborder-style: solid;\n\t\tborder-color: transparent;\n\t\tborder-width: 0 calc(var(--ck-todo-list-checkmark-size) / 8) calc(var(--ck-todo-list-checkmark-size) / 8) 0;\n\t\ttransform: rotate(45deg);\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]::before {\n\t\tbackground: hsl(126, 64%, 41%);\n\t\tborder-color: hsl(126, 64%, 41%);\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]::after {\n\t\tborder-color: hsl(0, 0%, 100%);\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t.ck-editor__editable.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox] {\n\t\tposition: absolute;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/list.css */\n\t.ck-content ol {\n\t\tlist-style-type: decimal;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/list.css */\n\t.ck-content ol ol {\n\t\tlist-style-type: lower-latin;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/list.css */\n\t.ck-content ol ol ol {\n\t\tlist-style-type: lower-roman;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/list.css */\n\t.ck-content ol ol ol ol {\n\t\tlist-style-type: upper-latin;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/list.css */\n\t.ck-content ol ol ol ol ol {\n\t\tlist-style-type: upper-roman;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/list.css */\n\t.ck-content ul {\n\t\tlist-style-type: disc;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/list.css */\n\t.ck-content ul ul {\n\t\tlist-style-type: circle;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/list.css */\n\t.ck-content ul ul ul {\n\t\tlist-style-type: square;\n\t}\n\n\t/* @ckeditor/ckeditor5-list/theme/list.css */\n\t.ck-content ul ul ul ul {\n\t\tlist-style-type: square;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imageresize.css */\n\t.ck-content img.image_resized {\n\t\theight: auto;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imageresize.css */\n\t.ck-content .image.image_resized {\n\t\tmax-width: 100%;\n\t\tdisplay: block;\n\t\tbox-sizing: border-box;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imageresize.css */\n\t.ck-content .image.image_resized img {\n\t\twidth: 100%;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imageresize.css */\n\t.ck-content .image.image_resized>figcaption {\n\t\tdisplay: block;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/image.css */\n\t.ck-content .image {\n\t\tdisplay: table;\n\t\tclear: both;\n\t\ttext-align: center;\n\t\tmargin: 0.9em auto;\n\t\tmin-width: 50px;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/image.css */\n\t.ck-content .image img {\n\t\tdisplay: block;\n\t\tmargin: 0 auto;\n\t\tmax-width: 100%;\n\t\tmin-width: 100%;\n\t\theight: auto;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/image.css */\n\t.ck-content .image-inline {\n\t\t/*\n     * Normally, the .image-inline would have \"display: inline-block\" and \"img { width: 100% }\" (to follow the wrapper while resizing).;\n     * Unfortunately, together with \"srcset\", it gets automatically stretched up to the width of the editing root.\n     * This strange behavior does not happen with inline-flex.\n     */\n\t\tdisplay: inline-flex;\n\t\tmax-width: 100%;\n\t\talign-items: flex-start;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/image.css */\n\t.ck-content .image-inline picture {\n\t\tdisplay: flex;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/image.css */\n\t.ck-content .image-inline picture,\n\t.ck-content .image-inline img {\n\t\tflex-grow: 1;\n\t\tflex-shrink: 1;\n\t\tmax-width: 100%;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image.image-style-block-align-left,\n\t.ck-content .image.image-style-block-align-right {\n\t\tmax-width: calc(100% - var(--ck-image-style-spacing));\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image.image-style-align-left,\n\t.ck-content .image.image-style-align-right {\n\t\tclear: none;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image.image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image.image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image.image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image.image-style-block-align-right {\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image.image-style-block-align-left {\n\t\tmargin-left: 0;\n\t\tmargin-right: auto;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content p+.image.image-style-align-left,\n\t.ck-content p+.image.image-style-align-right,\n\t.ck-content p+.image.image-style-side {\n\t\tmargin-top: 0;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image-inline.image-style-align-left,\n\t.ck-content .image-inline.image-style-align-right {\n\t\tmargin-top: var(--ck-inline-image-style-spacing);\n\t\tmargin-bottom: var(--ck-inline-image-style-spacing);\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image-inline.image-style-align-left {\n\t\tmargin-right: var(--ck-inline-image-style-spacing);\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagestyle.css */\n\t.ck-content .image-inline.image-style-align-right {\n\t\tmargin-left: var(--ck-inline-image-style-spacing);\n\t}\n\n\t/* @ckeditor/ckeditor5-basic-styles/theme/code.css */\n\t.ck-content code {\n\t\tbackground-color: hsla(0, 0%, 78%, 0.3);\n\t\tpadding: .15em;\n\t\tborder-radius: 2px;\n\t}\n\n\t/* @ckeditor/ckeditor5-block-quote/theme/blockquote.css */\n\t.ck-content blockquote {\n\t\toverflow: hidden;\n\t\tpadding-right: 1.5em;\n\t\tpadding-left: 1.5em;\n\t\tmargin-left: 0;\n\t\tmargin-right: 0;\n\t\tfont-style: italic;\n\t\tborder-left: solid 5px hsl(0, 0%, 80%);\n\t}\n\n\t/* @ckeditor/ckeditor5-block-quote/theme/blockquote.css */\n\t.ck-content[dir=\"rtl\"] blockquote {\n\t\tborder-left: 0;\n\t\tborder-right: solid 5px hsl(0, 0%, 80%);\n\t}\n\n\t/* @ckeditor/ckeditor5-highlight/theme/highlight.css */\n\t.ck-content .marker-yellow {\n\t\tbackground-color: var(--ck-highlight-marker-yellow);\n\t}\n\n\t/* @ckeditor/ckeditor5-highlight/theme/highlight.css */\n\t.ck-content .marker-green {\n\t\tbackground-color: var(--ck-highlight-marker-green);\n\t}\n\n\t/* @ckeditor/ckeditor5-highlight/theme/highlight.css */\n\t.ck-content .marker-pink {\n\t\tbackground-color: var(--ck-highlight-marker-pink);\n\t}\n\n\t/* @ckeditor/ckeditor5-highlight/theme/highlight.css */\n\t.ck-content .marker-blue {\n\t\tbackground-color: var(--ck-highlight-marker-blue);\n\t}\n\n\t/* @ckeditor/ckeditor5-highlight/theme/highlight.css */\n\t.ck-content .pen-red {\n\t\tcolor: var(--ck-highlight-pen-red);\n\t\tbackground-color: transparent;\n\t}\n\n\t/* @ckeditor/ckeditor5-highlight/theme/highlight.css */\n\t.ck-content .pen-green {\n\t\tcolor: var(--ck-highlight-pen-green);\n\t\tbackground-color: transparent;\n\t}\n\n\t/* @ckeditor/ckeditor5-font/theme/fontsize.css */\n\t.ck-content .text-tiny {\n\t\tfont-size: .7em;\n\t}\n\n\t/* @ckeditor/ckeditor5-font/theme/fontsize.css */\n\t.ck-content .text-small {\n\t\tfont-size: .85em;\n\t}\n\n\t/* @ckeditor/ckeditor5-font/theme/fontsize.css */\n\t.ck-content .text-big {\n\t\tfont-size: 1.4em;\n\t}\n\n\t/* @ckeditor/ckeditor5-font/theme/fontsize.css */\n\t.ck-content .text-huge {\n\t\tfont-size: 1.8em;\n\t}\n\n\t/* @ckeditor/ckeditor5-mention/theme/mention.css */\n\t.ck-content .mention {\n\t\tbackground: var(--ck-color-mention-background);\n\t\tcolor: var(--ck-color-mention-text);\n\t}\n\n\t/* @ckeditor/ckeditor5-table/theme/tablecaption.css */\n\t.ck-content .table>figcaption {\n\t\tdisplay: table-caption;\n\t\tcaption-side: top;\n\t\tword-break: break-word;\n\t\ttext-align: center;\n\t\tcolor: var(--ck-color-selector-caption-text);\n\t\tbackground-color: var(--ck-color-selector-caption-background);\n\t\tpadding: .6em;\n\t\tfont-size: .75em;\n\t\toutline-offset: -1px;\n\t}\n\n\t/* @ckeditor/ckeditor5-code-block/theme/codeblock.css */\n\t.ck-content pre {\n\t\tpadding: 1em;\n\t\tcolor: hsl(0, 0%, 20.8%);\n\t\tbackground: hsla(0, 0%, 78%, 0.3);\n\t\tborder: 1px solid hsl(0, 0%, 77%);\n\t\tborder-radius: 2px;\n\t\ttext-align: left;\n\t\tdirection: ltr;\n\t\ttab-size: 4;\n\t\twhite-space: pre-wrap;\n\t\tfont-style: normal;\n\t\tmin-width: 200px;\n\t}\n\n\t/* @ckeditor/ckeditor5-code-block/theme/codeblock.css */\n\t.ck-content pre code {\n\t\tbackground: unset;\n\t\tpadding: 0;\n\t\tborder-radius: 0;\n\t}\n\n\t/* @ckeditor/ckeditor5-horizontal-line/theme/horizontalline.css */\n\t.ck-content hr {\n\t\tmargin: 15px 0;\n\t\theight: 4px;\n\t\tbackground: hsl(0, 0%, 87%);\n\t\tborder: 0;\n\t}\n\n\t/* @ckeditor/ckeditor5-image/theme/imagecaption.css */\n\t.ck-content .image>figcaption {\n\t\tdisplay: table-caption;\n\t\tcaption-side: bottom;\n\t\tword-break: break-word;\n\t\tcolor: var(--ck-color-image-caption-text);\n\t\tbackground-color: var(--ck-color-image-caption-background);\n\t\tpadding: .6em;\n\t\tfont-size: .75em;\n\t\toutline-offset: -1px;\n\t}\n\n\t@media print {\n\n\t\t/* @ckeditor/ckeditor5-table/theme/table.css */\n\t\t.ck-content .table table {\n\t\t\theight: initial;\n\t\t}\n\n\t\t/* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */\n\t\t.ck-content .page-break {\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t/* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */\n\t\t.ck-content .page-break::after {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t/* @ckeditor/ckeditor5-page-break/theme/pagebreak.css */\n\t\t.ck-content *:has(+ .page-break) {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\n\t\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t\t.ck-content .todo-list .todo-list__label>input::before {\n\t\t\ttransition: none;\n\t\t}\n\n\t\t/* @ckeditor/ckeditor5-list/theme/todolist.css */\n\t\t.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input::before {\n\t\t\ttransition: none;\n\t\t}\n\t}\n\n\t@media (forced-colors: active) {\n\n\t\t/* @ckeditor/ckeditor5-table/theme/tablecaption.css */\n\t\t.ck-content .table>figcaption {\n\t\t\tbackground-color: unset;\n\t\t\tcolor: unset;\n\t\t}\n\n\t\t/* @ckeditor/ckeditor5-image/theme/imagecaption.css */\n\t\t.ck-content .image>figcaption {\n\t\t\tbackground-color: unset;\n\t\t\tcolor: unset;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
